import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import history from '../../services/history';

const images = [
  { url: '/images/agenda.jpg', title: 'Novo Agendamento' },
  { url: '/images/paciente.jpg', title: 'Meus Agendamentos' },
  { url: '/images/laudos.jpg', title: 'Resultado de Exames' },
];

export default function Dashboard() {
  const patient = useSelector(state => state.patient.patient);

  // TODO: melhorar esse dashboard com mais opções. próximo agendamento, laudos, etc...
  function handlePaciente(title) {
    if (title === 'Novo Agendamento') history.push(`/agendamento?cpf=${patient?.cpf || ''}`);
    if (title === 'Resultado de Exames') history.push('/paciente/exames');
    if (title === 'Meus Agendamentos') history.push('/paciente/agendamentos');
  }

  return (
    <>
      {images.map(image => (
        <Button
          onClick={() => handlePaciente(image.title)}
          key={image.title}
          style={{
            width: '33%',
            height: 200,
            backgroundImage: `url(${image.url})`,
            position: 'relative',
            margin: '2px',
          }}
        >
          <div
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: 30,
              backgroundColor: 'rgba(0, 0, 0, 0.4)',
              transition: 'background-color 0.7s',
            }}
            onMouseEnter={e =>
              (e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)')
            }
            onMouseLeave={e =>
              (e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.4)')
            }
          >
            <span>{image.title}</span>
          </div>
        </Button>
      ))}
    </>
  );
}
